/**
 * A content - which was blocked - got unblocked. This event is **not** dispatched
 * for each unblocked content in a "transaction", instead it is dispatched
 * when the transaction is complete (all content got unblocked and loaded).
 */ export const OPT_IN_CONTENT_BLOCKER_ALL = "RCB/OptIn/ContentBlocker/All";
